import { mcn } from "@/utils/baseProps.ts";
import type { ComponentProps } from "react";

export type MaskIconProps = ComponentProps<"span">;

export function MaskIcon(props: MaskIconProps) {
    return <span {...mcn("mask-icon inline-block", props)} />;
}
